import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { AttendanceDetailsTab } from '@/features/dashboard/tabs/attendance-details-tab'

export const Route = createFileRoute(
  '/_authenticated/dashboard/attendance-details'
)({
  beforeLoad: requireSuperAdmin,
  component: AttendanceDetailsTab,
})
